import { Button, Dialog, Heading, Modal } from 'react-aria-components';
import { UNSAFE_PortalProvider } from 'react-aria';
import { ComponentProps, ReactNode } from 'react';
import { Typography } from '../../atoms/typography/typography';
import { IconTimes } from '@maia/icons';
import { twMerge } from 'tailwind-merge';

export type SidedrawerProps = {
  children: ReactNode;
  title: string;
  portalRef?: HTMLDivElement | null;
  className?: string;
  isDismissable?: boolean;
} & Omit<ComponentProps<typeof Modal>, 'children'>;

export const SideDrawer = ({
  children,
  title,
  portalRef,
  className,
  isDismissable = true,
  ...props
}: SidedrawerProps) => {
  return (
    <UNSAFE_PortalProvider
      getContainer={portalRef ? () => portalRef : undefined}
    >
      <Modal
        isDismissable={isDismissable}
        className={twMerge(
          'absolute right-0 top-0 h-full bg-grayscale0 shadow-side-drawer overflow-y-auto max-h-full p-32 rounded-bl-24 data-[entering]:animate-side-drawer-in data-[exiting]:animate-side-drawer-out',
          className,
        )}
        {...props}
      >
        <Dialog>
          {({ close }) => (
            <>
              <Heading slot="title" className="flex items-center justify-between">
                <Typography
                  variant="display6"
                  weight="medium"
                  className="text-primaryMain"
                >
                  {title}
                </Typography>
                <Button slot="close" onPress={close}>
                  <IconTimes className="min-w-24 h-24 fill-info300" />
                </Button>
              </Heading>

              {children}
            </>
          )}
        </Dialog>
      </Modal>
    </UNSAFE_PortalProvider>
  );
};
